import { UrbanismRegulationZonesService } from '@/modules/administrator/services/urbanism-regulation-zones-service';
import Errors from '@/shared/error/errors';
import ApiService from '@/shared/services/api.service';

// action types
export const DO_FETCH = 'doFetch';
export const DO_SEARCH_UNIQUE_COMBO = 'doSearchUnique';

// mutation types
export const FETCH_SUCCESS = 'fetchSuccess';
export const SET_CURRENT_PAGE = 'setCurrentPage';
export const SET_FILTERS = 'setFilters';
export const UPDATE_RECORD = 'updateRecord';

const state = {
    rows: [],
    total: 0,
    storeFilters: {},
    currentPage: 1,
};

const getters = {
    rows: (state) => state.rows || [],
    total: (state) => state.total,
    filters: (state) => state.storeFilters,
    currentPage: (state) => state.currentPage,
};

const actions = {
    [DO_FETCH](context, payload) {
        return new Promise((resolve, reject) => {
            context.commit('shared/activateLoading', 'urbanismRegulations/get', { root: true });
            const filters = { params: { ...payload, pagination: true } };
            UrbanismRegulationZonesService.list(filters)
                .then((data) => {
                    context.commit(FETCH_SUCCESS, {
                        rows: data.data,
                        total: data?.pagination?.total,
                    });
                })
                .catch(( error ) => {
                    Errors.handle(error);
                    reject();
                })
                .finally(() => {
                    context.commit('shared/deactivateLoading', 'urbanismRegulations/get', { root: true });
                });
        });
    },
    [DO_SEARCH_UNIQUE_COMBO](context, payload) {
        return new Promise((resolve, reject) => {
            context.commit('shared/activateLoading', 'urbanismRegulations/search', { root: true });
            const {tenant_id, name, type} = payload;
            const query = `tenant_id eq '${tenant_id}' and name eq '${name}' and type eq '${type}'`

            ApiService.query('/urbanism-regulation-zones', {params: {
                    query,
                    sort: '-created_date',
                    limit: 100
                }
            })
            .then(({ data }) => {
                resolve(data);
            })
            .catch(({ error }) => {
                reject(error);
            })
            .finally(() => {
                context.commit('shared/deactivateLoading', 'urbanismRegulations/search', { root: true });
            })
        });
    }
};

const mutations = {
    [FETCH_SUCCESS](state, payload) {
        state.rows = payload.rows;
        state.total = payload.total;
    },
    [SET_CURRENT_PAGE](state, page) {
        state.currentPage = page;
    },
    [SET_FILTERS](state, { key, value }) {
        state.storeFilters[key] = value;
    },
    [UPDATE_RECORD](state, record) {
        const recordIndex = state.rows.findIndex((el) => el.id === record.id);
        Object.assign(state.rows[recordIndex], { ...record });
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
